// extracted by mini-css-extract-plugin
module.exports = {"root":"ResumeEdu_root__2UbBn","title":"ResumeEdu_title__3iTFb","location":"ResumeEdu_location__10Gc-"};